import internalApi from '@/utils/internalApi'
import Sortable from 'sortablejs'
import Swal from 'sweetalert2'
import Lang from './Lang'

export default class SortOrder {
    #element
    #sortable
    #handle
    #url

    constructor(element) {
        this.#element = element
        this.#handle = element.getAttribute('data-draggable-handle') ?? null
        this.#url = element.getAttribute('data-draggable-url') ?? false

        this.init()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new SortOrder(element))
    }

    init() {
        const target = this.#element.dataset.gpTarget

        this.#sortable = Sortable.create(this.#element, {
            draggable: target,
            onEnd: this.#onDragEnd,
            filter: '.ignore-sortable',
            preventOnFilter: false,
            handle: this.#handle,
        })
    }

    #onDragEnd = async (el) => {
        let sortOrder = []
        const iconEl = el.item.querySelector('[data-draggable-icon]')

        if (this.#url && iconEl) {
            iconEl.innerHTML =
                '<div class="spinner-border spinner-border-sm" role="status">\n' +
                '  <span class="visually-hidden">Loading...</span>\n' +
                '</div>'
        }

        this.#element.querySelectorAll('[data-draggable-id]').forEach(function (element, index) {
            const hiddenEl = element.querySelector('.gp-draggable-order')
            const textEl = element.querySelector('.gp-draggable-order-text-1')

            if (hiddenEl) {
                hiddenEl.value = index
            }

            if (textEl) {
                textEl.innerText = index + 1
            }

            sortOrder.push(element.getAttribute('data-draggable-id'))
        })

        if (this.#url) {
            this.#sortable.option('disabled', true)

            try {
                await internalApi.post(this.#url, { sort_order: sortOrder })

                if (iconEl) {
                    iconEl.innerHTML = '<i class="bi bi-check text-success text-lg"></i>'
                }
            } catch (error) {
                if (iconEl) {
                    iconEl.innerHTML = '<i class="bi bi-x-lg text-danger"></i>'
                }

                if (error.response.status === 422) {
                    Swal.fire({
                        icon: 'error',
                        title: Lang.get('general.oops'),
                        text: error.response.data.message,
                    })

                    return
                }

                Swal.fire({
                    icon: 'error',
                    title: Lang.get('general.oops'),
                    text: error.response.data.message,
                })
            } finally {
                this.#sortable.option('disabled', false)

                if (iconEl) {
                    setTimeout(function () {
                        iconEl.innerHTML = '<i class="bi bi-grip-vertical text-lg"></i>'
                    }, 2000)
                }
            }
        }
    }
}
